<template>
    <div class="mall">
        <van-sticky>
            <van-nav-bar title="领取产品" left-arrow @click-left="$router.go(-1)" />
        </van-sticky>
        <div v-if='list.length>0'>
            <!-- 商品 -->
            <div class="shop-content">
                <div class="shop-nav" @click="
                  $router.push({ path: 'trialPay', query: { id: item.id ,freight:item.freight} })
                " v-for="(item, index) in list" :key="index">
                    <img :src="item.image" />
                    <div class="goodsBtm">
                        <div class="goodsName textEllipsis-2">{{ item.name }}</div>
                        <div class="goodsDesc">
                            <div class="goodsPrice">
                                ￥
                                <span>{{ item.price }}</span>
                            </div>
                            <div class="goodsVolume">{{ item.sales }}人付款</div>
                        </div>
                        <!-- <div class="shop-but">立即购买</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="noData">
            暂无数据
        </div>
    </div>
</template>
<script>
    import {
        trialList
    } from "@/api/personal";
    export default {
        data() {
            return {
                list: []
            };
        },
        created() {
            trialList().then(res => {
                this.list = res;
            })
        }
    }
</script>
<style lang="less" scoped>
    .mall {
        padding-bottom: 70px;
        background: #F7FBFF;
    }

    .shop-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 12px;

        .shop-nav {
            width: 49%;
            border-radius: 8px;
            background: #fff;
            margin-top: 7.5px;
            border-bottom: 1px solid rgba(146, 146, 146, 0.35);
            font-size: 14px;
            position: relative;


            img {
                width: 100%;
                height: 157.5px;
                border-radius: 8px 8px 0 0;
            }

            .goodsBtm {
                padding: 0 11px 22.5px;
                box-sizing: border-box;

                .shop-but {
                    width: 80px;
                    text-align: center;
                    background: #FF6187;
                    color: white;
                    margin: 10px 0;
                    float: right;
                    height: 32px;
                    line-height: 32px;
                    font-size: 12px;
                    border-radius: 15px;
                    padding: 0;
                    text-align: center;
                }
            }

            .goodsName {
                height: 38px;
                color: #333;
            }
        }
    }
    .goodsDesc {
    display: flex;
    margin-top: 15px;

    .goodsPrice {
      color: #FF6187;
    }

    .goodsVolume {
      color: #666;
      font-size: 13px;
      margin-left: 10px;
    }
  }
</style>